import PropTypes from 'prop-types';

const StylePropType = PropTypes.oneOfType([
  PropTypes.number,
  PropTypes.object,
  PropTypes.arrayOf(PropTypes.object),
]);

export {
  // eslint-disable-next-line import/prefer-default-export
  StylePropType,
};
